import React, { useEffect } from 'react';
import { BrowserRouter, Switch, Redirect, Route } from 'react-router-dom';
import AdminBulkOrder from '../screens/admin/BulkOrder';
import AdminDatabase from '../screens/admin/Database';
import AdminGroupOrders from '../screens/admin/OrderGroup';
import AdminOrders from '../screens/admin/Order';
import AdminOrderDetail from '../screens/admin/OrderDetail';
import AdminOrdersByStatus from '../screens/admin/OrderByStatus';
import AdminTransactions from '../screens/admin/Transaction';
import AdminMenu from '../screens/admin/Menu';
import AdminPurchaseOrder from  '../screens/admin/PurchaseOrder';
import AdminPurchaseOrderDetail from '../screens/admin/PurchaseOrderDetail';
import AdminPurchaseOrderPDF from '../screens/admin/PurchaseOrderPdf';
import AdminPostCodeCorrection from '../screens/admin/PostalCodeCorrector';
import AdminInventory from '../screens/admin/UserDetail/Inventory';
import AdminInvoice from '../screens/admin/Invoice';
import AdminStockUpdate from '../screens/admin/StockUpdate';
import AdminUser from '../screens/admin/User';
import AdminUserDetail from '../screens/admin/UserDetail';
import Address from '../screens/address';
import Agent from '../screens/home/Agent';
import Analytics from '../screens/analytics';
import ApiCreated from "../screens/key/Created";
import APIForm from "../screens/key/APIForm";
import Billing  from "../screens/billing";
import Catalog from '../screens/catalog';
import CatalogPayment from "../screens/form/Payment";
import Complaints from '../screens/home/Complaints';
import CourierRates from '../screens/home/ShippingRates';
import DocsAuth from '../screens/docs/Authentication';
import DocsCourier from '../screens/docs/couriers/Object';
import DocsCourierList from '../screens/docs/couriers/List';
import DocsOrder from '../screens/docs/orders/Object';
import DocsRates from '../screens/docs/rates/Object';
import DocsRatesAreaId from '../screens/docs/rates/AreaId';
import DocsRatesPostalCode from '../screens/docs/rates/PostalCode';
import DocsRatesCoordinate from '../screens/docs/rates/Coordinate';
import DocsRatesBoth from '../screens/docs/rates/Both';
import DocsMaps from '../screens/docs/maps/Object';
import DocsMapsArea from '../screens/docs/maps/Area';
import DocsDoubleMapsArea from '../screens/docs/maps/DoubleSearch';
import DocsErrors from '../screens/docs/Errors';
import DocsIntro from '../screens/docs/Introduction';
import FAQ from '../screens/home/FAQ';
import ForgotPassword from '../screens/user/ForgotPassword'
import Fulfillment from '../screens/home/Fulfillment';
import Form from '../screens/form';
import IntegrationCreated from '../screens/key/Success';
import IntegrationKeyUsage from '../screens/key/Usage';
import Key from '../screens/key';
import Landing from '../screens/home/Landing';
import Layout from '../screens/__layout';
import NewPassword from '../screens/user/NewPassword';
import Order from '../screens/order';
import PayoutForm from '../screens/billing/PayoutForm';
import PublicCatalog from '../screens/form/Public';
import PublicTracking from '../screens/tracking/PublicTracking';
import PublicInvoice from '../screens/invoice/PublicInvoice';
import Privacy from '../screens/home/Privacy';
import Pricing from '../screens/home/Pricing';
import PostpaidForm from '../screens/setting/PostpaidForm';
import Setting from '../screens/setting'
import Shipment from '../screens/home/Shipment';
import SignUp from '../screens/user/SignUp';
import SignIn from '../screens/user/SignIn';
import SignInCommunity from '../screens/user/SignInCommunity';
import Ticket from '../screens/ticket';
import Plugin from '../screens/home/Plugins';

// Routes
import AdminRoute from './AdminRoute';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';

// Analytics
import { trackPageView } from '../services/analytics';

const publicRoutes = [
  { path:"/",component:Landing},
  { path:"/complaints",component:Complaints},  
  { path:"/agent-registration",component:Agent},  
  { path:"/catalog/pf/:catalogId/:catalogName",component:PublicCatalog},
  { path:"/catalog/pf/:orderId/:uniqueCode/payment",component:CatalogPayment},
  { path:"/docs/api",component:DocsIntro},
  { path:"/docs/api/authentication",component:DocsAuth},
  { path:"/docs/api/errors",component:DocsErrors},
  { path:"/docs/api/couriers",component:DocsCourier},
  { path:"/docs/api/couriers/list",component:DocsCourierList},
  { path:"/docs/api/rates",component:DocsRates},
  { path:"/docs/api/orders",component:DocsOrder},
  { path:"/docs/api/maps",component:DocsMaps},
  { path:"/docs/api/maps/single_search_area",component:DocsMapsArea},
  { path:"/docs/api/maps/double_search_area",component:DocsDoubleMapsArea},
  { path:"/docs/api/rates/couriers_area_id",component:DocsRatesAreaId},
  { path:"/docs/api/rates/couriers_postal_code",component:DocsRatesPostalCode},
  { path:"/docs/api/rates/couriers_coordinate",component:DocsRatesCoordinate},
  { path:"/docs/api/rates/couriers_mix",component:DocsRatesBoth},
  { path:"/forgot_password/new",component:ForgotPassword},
  { path:"/fulfillment",component:Fulfillment},
  { path:"/help/faq",component:FAQ},
  { path:"/new_password/:token",component:NewPassword},
  { path:"/privacy",component:Privacy},
  { path:"/pricing",component:Pricing},
  { path:"/rates/courier",component:CourierRates},
  { path:"/cek-ongkir",component:CourierRates},
  { path:"/cek-resi",component:PublicTracking},
  { path:"/signin",component:SignIn},
  { path:"/signin/community",component:SignInCommunity},
  { path:"/signup",component:SignUp},
  { path:"/shipping",component:Shipment},
  { path:"/t/:shortOrderId",component:PublicTracking},
  { path:"/plugin",component:Plugin},
]


const Routes = () => {

  useEffect(() => {
    trackPageView(window.location.pathname + window.location.search);
  }, []);


  return (
    <BrowserRouter>
      <Switch>
        {
          publicRoutes.map((i,idx) => (
              <PublicRoute key={idx} path={i.path} exact component={i.component} />
          ))
        }
        <Layout>
          <Switch>
            <PrivateRoute path="/address" exact component={Address} />
            <PrivateRoute path="/billing" exact component={Billing} />
            <PrivateRoute path="/billing/payout-form" exact component={PayoutForm} />
            <PrivateRoute path="/catalog" exact component={Catalog} />
            <PrivateRoute path="/tickets" exact component={Ticket} />
            <PrivateRoute path="/form" exact component={Form} />
            <PrivateRoute path="/integrations" exact component={Key} />
            <PrivateRoute path="/integrations/:key" exact component={ApiCreated} />
            <PrivateRoute path="/integrations/:name/success" exact component={IntegrationCreated} />
            <PrivateRoute path="/integrations/api/keys/:key" exact component={IntegrationKeyUsage} />
            
            <PrivateRoute path="/overview" exact component={Order} />
            <PrivateRoute path="/setting" exact component={Setting} />
            <PrivateRoute path="/analytics" exact component={Analytics} />
            <PrivateRoute path="/api-production-form" exact component={APIForm} />
            
            <PrivateRoute path="/postpaid-registration" exact component={PostpaidForm} />
            <PrivateRoute path="/invoices/:invoiceId" exact component={PublicInvoice}/>
            <AdminRoute path="/admin" exact component={AdminMenu} />
            <AdminRoute path="/admin/orders" exact component={AdminOrders} />
            <AdminRoute path="/admin/orders/:orderId" exact component={AdminOrderDetail} />
            <AdminRoute path="/admin/orders/status/:status" exact component={AdminOrdersByStatus} />
            <AdminRoute path="/admin/orders/new/bulk" exact component={AdminBulkOrder} />
            <AdminRoute path="/admin/orders/group/users" exact component={AdminGroupOrders} />
            <AdminRoute path="/admin/database" exact component={AdminDatabase} />
            <AdminRoute path="/admin/invoices" exact component={AdminInvoice} />
            <AdminRoute path="/admin/purchase-orders" exact component={AdminPurchaseOrder} />
            <AdminRoute path="/admin/purchase-orders/:purchaseOrderId" exact component={AdminPurchaseOrderDetail} />
            <AdminRoute path="/admin/purchase-orders/:purchaseOrderId/download-pdf" exact component={AdminPurchaseOrderPDF} />
            <AdminRoute path="/admin/inventories/:userId" exact component={AdminInventory} />
            <AdminRoute path="/admin/stock-update/:sku" exact component={AdminStockUpdate}/>
            <AdminRoute path="/admin/postal-code" exact component={AdminPostCodeCorrection}/>
            <AdminRoute path="/admin/users" exact component={AdminUser} />
            <AdminRoute path="/admin/users/:userId" exact component={AdminUserDetail} />
            <AdminRoute path="/admin/transactions" exact component={AdminTransactions} />
          </Switch>
        </Layout>

      </Switch>
    </BrowserRouter>
  );
};


export default Routes;
